import { render, staticRenderFns } from "./PopoverBulkActions.vue?vue&type=template&id=07bb3dd7&scoped=true"
import script from "./PopoverBulkActions.vue?vue&type=script&lang=js"
export * from "./PopoverBulkActions.vue?vue&type=script&lang=js"
import style0 from "./PopoverBulkActions.vue?vue&type=style&index=0&id=07bb3dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb3dd7",
  null
  
)

export default component.exports